import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import updateSSOProvider from '@/API/SSO/updateSSOProvider';

const useUpdateSSOProvider = () => {
    return useMutation({
        mutationFn: updateSSOProvider,
        onSuccess: () => {
            toast.success('Provider has been updated successfully!');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        },
    });
};

export default useUpdateSSOProvider;
